import { render, staticRenderFns } from "./CountriesBoard.vue?vue&type=template&id=6353d1c8&scoped=true&"
import script from "./CountriesBoard.vue?vue&type=script&lang=js&"
export * from "./CountriesBoard.vue?vue&type=script&lang=js&"
import style0 from "./CountriesBoard.vue?vue&type=style&index=0&id=6353d1c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6353d1c8",
  null
  
)

export default component.exports